import React from 'react'
import Footer from '../Components/Footer/Footer'
import RegisterUser from '../Components/RegisterUser/RegisterUser'
function CreateUser() {
  return (
    <div>
      <RegisterUser/>
      <Footer/>
    </div>
  )
}

export default CreateUser
